import React, { useState } from "react";
import "../../../../css/Common/Components/Cards/MeetTheTeamCard.css";
import "../../../../css/App.css";
import { useNavigate } from "react-router-dom";

/**
 * MeetTheTeamCard component displays a team member's card with a flip animation.
 * On click, the card flips to reveal the member's bio on the back side.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.imgSrc - Source URL for the team member's image.
 * @param {string} props.name - Name of the team member.
 * @param {string} props.role - Role or position of the team member.
 * @param {string} props.bio - Short biography or description of the team member.
 * @param {string} props.altText - Alternative text for the team member's image.
 * @param {string} [props.title] - Optional title or prefix for the team member's name.
 * @returns {JSX.Element} The rendered MeetTheTeamCard component.
 */
const MeetTheTeamCard = ({ imgSrc, name, role, bio, altText ,title=""}) => {
  const navigate = useNavigate();
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleFlip = () => {
    setIsFlipped((prev) => !prev);
  };

  return (
    <div
      className={`Meet-The-Team ${isFlipped ? "flipped" : ""}`}
      onClick={toggleFlip}
    >
      <div className="Meet-The-Team-inner">
        {/* Front Side */}
        <div className="Meet-The-Team-front">
          <img loading="eager"  src={imgSrc} alt={altText} />
          <h3 className={`${title ? "" : "Without-Title"}`}>
            <div className="Content-Small">{title || ""}</div>
            {name}
          </h3>
          <div className="Role-Container">
            <h4>{role}</h4>
          </div>
        </div>

        {/* Back Side */}
        <div className="Meet-The-Team-back">
          <div className="Content">{bio}</div>
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeamCard;
